import { Button } from '@fluentui/react-components';
import { FilterDismissRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

export interface ClearFilterButtonProps {
    onClick: () => void;
}

const ClearFilterButton: React.FC<ClearFilterButtonProps> = ({ onClick }) => {
    const { t } = useTranslation();

    return (
        <Button
            onClick={onClick}
            icon={<FilterDismissRegular />}
            appearance="subtle"
        >
            {t('Button_Filter_Clear')}
        </Button>
    );
};

export default ClearFilterButton;
